import type { MeetingLocationType, MeetingStatus } from "@/lib/db-types";
import type { StatusTone } from "@/lib/widget-status";

export const MEETING_STATUS_LABELS: Record<MeetingStatus, string> = {
  scheduled: "Planlagt",
  held: "Avholdt",
  cancelled: "Avlyst",
  no_show: "Kunden møtte ikke",
  unknown: "Status ukjent",
};

export const MEETING_STATUS_TONES: Record<MeetingStatus, StatusTone | null> = {
  scheduled: null,
  held: "reached",
  cancelled: "miss",
  no_show: "miss",
  unknown: "near",
};

export const MEETING_LOCATION_LABELS: Record<MeetingLocationType, string> = {
  meet: "Google Meet",
  physical: "Fysisk møte",
};
